export default {
    init: function() {
        let prevVisible = false;
        let prevBeforeVisible = false;
        this.on('update', function() {
            if (this.opts.if !== prevBeforeVisible) {
                if (this.opts.if === true) {
                    this.trigger('before-visible');
                }
                prevBeforeVisible = this.opts.if;
            }
        });

        this.on('updated', function() {
            if (this.opts.if !== prevVisible) {
                if (this.opts.if === true) {
                    this.trigger('visible');
                }
                prevVisible = this.opts.if;
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal-mixin.js